import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { BrowserModule , Title} from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import 'rxjs/add/operator/toPromise';
import { HttpClientModule } from '@angular/common/http';
// Routes
import { routes } from './app-routing.module';
import { AppComponent } from './app.component';
import { ShoppingCartModule } from './shoppingcart';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OrdinalPipe } from './core/pipes/ordinal.pipes';
import { UspsService } from './core/services/usps.service';
import { UspsDialogComponent } from './shoppingcart/usps-dialog/usps-dialog.component';
import { FooterService } from './core/services/footer.services';
@NgModule({
  declarations: [
    AppComponent,
    OrdinalPipe
  ],
  imports: [
    BrowserModule,
    CommonModule,
    HttpModule,
    RouterModule.forRoot(routes, {}),
    ShoppingCartModule,
    BrowserAnimationsModule,
    NgbModule.forRoot(),
    HttpClientModule
  ],
  providers: [
    UspsService,
    UspsDialogComponent,
    FooterService,
 [Title],
 [OrdinalPipe]
],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts